/**
 * Every word Controls shows (P1.9-T50), and each action's name. "Press a key", the waiting line and the clash's
 * line are the design's (`SettingsSurfaces.jsx`, states `rebind` and `conflict`); the rest are drafts for the
 * author. Sprint is the author's word (2026-10-08), in the action's name and in Sprint mode. Lock the ability bar
 * and Reset ability bar are ADR-121's (decisions 3.2 and 2.5). Move (arrows) and Keyboard layout with its choices
 * are P1.9-T174's. A line for a refused key is short, and none explains the rule behind it. Menu is the name of
 * the one action whose key is fixed. `{slot}` is an ability's place on the bar, as the page prints it.
 */
export const CONTROLS = {
  runMode: "Sprint mode",
  barLock: "Lock the ability bar",
  barReset: "Reset ability bar",
  barResetButton: "Reset",
  barResetBody: "Every slot goes back to how a new character's bar stands.",
  pressKey: "Press a key",
  unbound: "Unbound",
  resetOne: "Reset",
  waiting: "Press a key for {action}. Esc cancels.",
  clash: "{key} is already {holder}. Apply to swap them.",
  move: "Move",
  moveArrows: "Move (arrows)",
  layout: "Keyboard layout",
  layoutChoices: { auto: "Auto", qwerty: "QWERTY", azerty: "AZERTY", qwertz: "QWERTZ", dvorak: "Dvorak" },
  refused: {
    unusable: "{key} can't be used.",
    unnamed: "That key can't be used.",
    shortcut: "No Ctrl, Alt or Cmd.",
  },
  swapRefused: "{action} would get {key}.",
  cap: "{action}, {key}",
  capChanged: "{action}, {key}, changed",
  capWaiting: "{action}, press a key",
  fixed: "{action}, {keys}, fixed",
  said: "{action}: {key}",
  menu: "Menu",
  ability: "Ability {slot}",
  actions: {
    moveUp: "Move up",
    moveLeft: "Move left",
    moveDown: "Move down",
    moveRight: "Move right",
    moveUpAlt: "Move up (arrows)",
    moveLeftAlt: "Move left (arrows)",
    moveDownAlt: "Move down (arrows)",
    moveRightAlt: "Move right (arrows)",
    interact: "Interact",
    run: "Sprint",
    jump: "Jump",
    swapPage: "Swap bar page",
    target: "Target nearest",
    stance: "Draw or sheathe",
    openChat: "Open chat",
    inventory: "Inventory",
    characterSheet: "Character",
    worldMap: "Map",
    flag: "PvP flag",
    emotes: "Emotes",
    itemNames: "Show item names",
    performance: "Performance",
    collision: "Collision view",
    toolCycle: "Next tool",
    tool1: "Tool 1",
    tool2: "Tool 2",
    tool3: "Tool 3",
    tool4: "Tool 4",
    companion: "Send companion out or home",
  },
} as const;
